import { whiteColor } from 'assets/jss/material-dashboard-pro-react';

const subscriptionTooltipStyle = () => ({
	wrapper: {
		'& p': {
			color: whiteColor,
		},
	},
	services: {
		marginTop: 16,
	},
});

export default subscriptionTooltipStyle;
